import React from "react";
import { ClipboardList, X } from "lucide-react";

const CdrStagingBubble = ({ count, onOpen, onClear, isDark }) => {
  if (!count) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[1100] flex items-center gap-2">
      <button
        type="button"
        onClick={onOpen}
        className={`group relative flex items-center gap-2 rounded-full px-4 py-2.5 shadow-lg border transition-all hover:scale-[1.02] ${
          isDark
            ? "bg-violet-600/90 border-violet-400/40 text-white hover:bg-violet-500"
            : "bg-violet-600 border-violet-500 text-white hover:bg-violet-700"
        }`}
        title="Sepetteki çağrı kayıtlarını görüntüle"
      >
        <ClipboardList className="w-4 h-4 shrink-0" />
        <span className="text-sm font-semibold tabular-nums">{count}</span>
        <span className="text-xs opacity-90 hidden sm:inline">CDR sepeti</span>
        <span
          className={`absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center ${
            isDark ? "bg-emerald-500 text-white" : "bg-emerald-400 text-emerald-950"
          }`}
        >
          {count}
        </span>
      </button>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onClear();
        }}
        className={`rounded-full p-2 border shadow-md transition-colors ${
          isDark
            ? "bg-slate-900/90 border-slate-700 text-slate-300 hover:text-white hover:bg-slate-800"
            : "bg-white border-gray-200 text-gray-500 hover:text-gray-800 hover:bg-gray-50"
        }`}
        title="Sepeti temizle"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default CdrStagingBubble;
